import { API_APARTMENT_AUTOCOMPLETE } from '../consts/endpoints'

export const fetchApartmentAutocomplete = async (query) => {
    const url = `${API_APARTMENT_AUTOCOMPLETE}?q=${encodeURIComponent(query)}`

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })

    const dataResponse = await response.json();

    if (!response.ok) {
        throw new Error(dataResponse.message || 'Autocomplete request failed');
    }

    if (dataResponse.status === true && Array.isArray(dataResponse.list)) {
        return dataResponse.list;
    }

    return [];
}


